import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {translate} from "../../components/Language/Translate";
import Spinner from "../../components/Spinner";
import FormValidation from "../Validation/FormValidation";
import {Button, Col, Form} from "react-bootstrap";
import {addKlausurDummy} from "../../actions/currentKlausur";
import FormField from "../FormField";
import KlausurSchema from "./KlausurSchema";
import {handleSaveProject} from "../../helpers/saveProject";

const KlausurEdit = ({setView}) => {
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const companies = useSelector(st => st.companies);
  const currentUser = useSelector(st => st.currentUser);
  const currentKlausur = useSelector(st => st.currentKlausur);
  const schueler = useSelector(st => st.schueler);
  const dispatch = useDispatch();
  const land = companies.find(c => c.id === parseInt(variables.companyId))?.land;

  useEffect(() => {
    const fetch = async () => {
      const fields = new KlausurSchema(companies, currentUser).fields;
      setFieldSettings({...fields});
      const vars = {};
      Object.keys(fields).forEach(k => (vars[k] = currentKlausur[k] || ""));
      setVariables({...vars});
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  });

  useEffect(() => {
    const schema = new KlausurSchema(companies, currentUser);
    console.log({schema});
    setFieldSettings(fs => {
      return {...schema.getFields(variables)};
    });
  }, [variables, setFieldSettings, companies, currentUser]);

  useEffect(() => {
    if (!variables.prozentAfb1 || !variables.prozentAfb2) return;
    setVariables(vars => {
      return {
        ...vars,
        prozentAfb3: 100 - variables.prozentAfb1 - variables.prozentAfb2
      };
    });
  }, [variables.prozentAfb1, variables.prozentAfb2]);
  useEffect(() => {
    if (variables.pruefungsart?.includes("a") && variables.sprachverwendung)
      setVariables(vars => {
        return {...vars, sprachverwendung: 15};
      });
  }, [variables.pruefungsart, variables.sprachverwendung]);
  useEffect(() => {
    if (variables.pruefungsart?.includes("a") && land !== "Brandenburg")
      setFieldSettings(fs => {
        return {
          ...fs,
          gutachter: {...fs.gutachter, validation: {minLength: 1}}
        };
      });
  }, [variables.pruefungsart]);

  if (isLoading) return <Spinner />;

  const resetInactiveVarsToInitialValue = () => {
    const schema = new KlausurSchema(companies, currentUser);
    const _allFields = schema.fields;
    const _allKeys = Object.keys(_allFields);
    const _activeKeys = Object.keys(fieldSettings);
    const _inactiveKeys = _allKeys.filter(k => !_activeKeys.includes(k));
    const _vars = {...variables};
    console.log({_allKeys, _activeKeys, _inactiveKeys, _vars});
    _inactiveKeys.forEach(k => {
      console.log(k, _allFields[k], _allFields[k]?.initialValue);
      _vars[k] = schema.getEmpty(_vars[k]);
    });
    return _vars;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const formValidation = new FormValidation({
      fieldSettings,
      variables,
      setFieldErrors
    });
    if (!formValidation.valid) return;
    const data = {
      ...currentKlausur,
      ...resetInactiveVarsToInitialValue(),
      updatedAt: new Date().toISOString(),
      updatedBy: currentUser.username
    };
    dispatch(addKlausurDummy(data));
    handleSaveProject(data, companies, schueler);
  };

  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError
  };
  console.log({props});
  console.log({currentKlausur, schueler, companies, variables});

  return (
    <div className="m-2 p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
      <Form.Row className="row row-eq-height">
        {Object.values(fieldSettings).map(lf => (
          <Col key={lf.name} id={lf.name} className={`col-${lf.col}`}>
            <FormField props={{...props, name: lf.name}} />
          </Col>
        ))}
      </Form.Row>
      <Form.Row>
        <Col>
          <Button block className="btn btn-outline-dark" onClick={handleSubmit}>
            {translate("Submit")}
          </Button>
        </Col>
        <Col>
          <Button block className="btn btn-secondary" onClick={() => setView("buttons")}>
            {translate("Cancel")}
          </Button>
        </Col>
      </Form.Row>
    </div>
  );
};
export default KlausurEdit;
